import { render, staticRenderFns } from "./MultimediaSection.vue?vue&type=template&id=186d70fe&scoped=true&"
import script from "./MultimediaSection.vue?vue&type=script&lang=js&"
export * from "./MultimediaSection.vue?vue&type=script&lang=js&"
import style0 from "./MultimediaSection.vue?vue&type=style&index=0&id=186d70fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186d70fe",
  null
  
)

export default component.exports